module.exports = __webpack_public_path__ + "img/intermediate.d169cee6.svg";